<div class="ledger-card" *ngIf="payload" role="region" [attr.aria-label]="title">
    <div class="ledger-head">
        <span class="ledger-icon">
            <i class="ph-bold ph-chart-line-up icon-primary icon-24" aria-hidden="true"></i>
        </span>
        <div class="ledger-meta">
            <div class="ledger-title">{{ title }}</div>
            <div class="ledger-sub" *ngIf="subtitle">{{ subtitle }}</div>
            <div class="ledger-period" *ngIf="periodLabel">{{ periodLabel }}</div>
        </div>
    </div>

    <!-- Highlights — the top-line metric grid. Money and count highlights both
         just render the server-formatted string; the UI never reformats. -->
    <div class="ledger-highlights" *ngIf="highlights.length > 0">
        <div
            class="ledger-highlight"
            *ngFor="let highlight of highlights; trackBy: trackByHighlightKey">
            <span class="ledger-highlight-label">{{ highlight.label }}</span>
            <span class="ledger-highlight-value">{{ highlight.formattedValue }}</span>
        </div>
    </div>

    <!-- Checks — reconciliation/balance assertions the analysis ran. -->
    <div class="ledger-checks" *ngIf="checks.length > 0">
        <div class="ledger-check" *ngFor="let check of checks; trackBy: trackByCheckKey">
            <i
                class="ph-bold {{ checkIcon(check.status) }} {{ checkIconColorClass(check.status) }} icon-16"
                aria-hidden="true"></i>
            <span class="ledger-check-label">{{ check.label }}</span>
            <span class="ledger-check-detail" *ngIf="check.formattedDifference">
                {{ check.formattedDifference }}
            </span>
            <span class="ledger-check-detail" *ngIf="!check.formattedDifference && check.detail">
                {{ check.detail }}
            </span>
        </div>
    </div>

    <!-- Tables — one block per result table, columns/rows entirely server-driven. -->
    <div class="ledger-table-block" *ngFor="let table of tables; trackBy: trackByTableKey">
        <div class="ledger-table-title">{{ table.title }}</div>
        <div class="ledger-table-scroll">
            <table class="ledger-table">
                <thead>
                    <tr>
                        <th
                            *ngFor="let column of table.columns; trackBy: trackByColumnKey"
                            [class.is-numeric]="column.type === 'money' || column.type === 'count'">
                            {{ column.label }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of table.rows; trackBy: trackByRowIndex">
                        <td
                            *ngFor="let column of table.columns; trackBy: trackByColumnKey"
                            [class.is-numeric]="column.type === 'money' || column.type === 'count'">
                            <ng-container *ngIf="isMoneyCell(cellValue(row, column.key)); else rawCell">
                                {{ $any(cellValue(row, column.key)).formattedValue }}
                            </ng-container>
                            <ng-template #rawCell>{{ cellValue(row, column.key) }}</ng-template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="ledger-table-truncated" *ngIf="table.truncated">
            Showing {{ table.returnedCount }} of {{ table.totalCount ?? table.returnedCount }}
        </div>
    </div>

    <!-- Warnings — surfaced via the standard V2 alert block, not baked into prose. -->
    <app-alert-block
        *ngFor="let warning of warnings; trackBy: trackByWarningKey"
        type="warn"
        class="ledger-warning">
        {{ warning.message }}
    </app-alert-block>
</div>
